import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IHomematchPreleadListItem} from "../types/IHomematchPrelead";

export const trackHomematchTinderDeckOpen = (params: {preleadsCount: number}) => {
    trackAmplitudeEvent("homematch_tinder_open", {
        location: "homepage",
        preleads_count: params.preleadsCount
    });
};

export const trackHomematchTinderSwipe = (params: {prelead: IHomematchPreleadListItem; direction: "accept" | "reject"}) => {
    trackAmplitudeEvent("homematch_tinder_swipe", {
        location: "homepage",
        direction: params.direction,
        prelead_id: params.prelead.id,
        property_id: params.prelead.property.id,
        offer_name: params.prelead.property.offer?.name ?? null
    });
};

export const trackHomematchTinderDeckEmpty = () => {
    trackAmplitudeEvent("homematch_tinder_deck_empty", {
        location: "homepage"
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IHomematchPreleadListItem} from "../types/IHomematchPrelead";

export const trackHomematchTinderDeckOpen = (params: {preleadsCount: number}) => {
    trackAmplitudeEvent("homematch_tinder_open", {
        location: "homepage",
        preleads_count: params.preleadsCount
    });
};

export const trackHomematchTinderSwipe = (params: {prelead: IHomematchPreleadListItem; direction: "accept" | "reject"}) => {
    trackAmplitudeEvent("homematch_tinder_swipe", {
        location: "homepage",
        direction: params.direction,
        prelead_id: params.prelead.id,
        property_id: params.prelead.property.id,
        offer_name: params.prelead.property.offer?.name ?? null
    });
};

export const trackHomematchTinderDeckEmpty = () => {
    trackAmplitudeEvent("homematch_tinder_deck_empty", {
        location: "homepage"
    });
};
